import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import store from "@/state/store";
import vuetify from './plugins/vuetify';
import InstantSearch from 'vue-instantsearch';
import firebase from 'firebase/app';
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/analytics'
import 'firebase/storage'
import 'firebase/functions'
import vueSignature from "vue-signature"
import firebaseConfig from './firebaseConfig'
import VueCurrencyFilter from 'vue-currency-filter'
Vue.use(VueCurrencyFilter, {
  symbol : '$',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
})
firebase.initializeApp(firebaseConfig)
Vue.config.productionTip = false
Vue.use(require('vue-moment'));
Vue.use(InstantSearch)
Vue.use(vueSignature)

// if (location.hostname === "localhost") {
//   /* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */
//   console.log('------------------')
//   // console.info('USING LOCAL DEV')
//   console.log('%c DEV MODE! ', 'background: #183757; color: #ffff');
//   console.log('------------------')
//   firebase.firestore().settings({
//     host: "localhost:9999",
//     ssl: false,
//     experimentalForceLongPolling: true // fix for weird bug on local where docs dont load
//   });
//   firebase.functions().useFunctionsEmulator("http://localhost:5001");
// }

const fb = {
  firebase: firebase,
  auth: firebase.auth(),
  db: firebase.firestore(),
  analytics: firebase.analytics(),
  storage: firebase.storage(),
  functions: firebase.functions(),
  signInSheetsStorage: firebase.app().storage('gs://alba-demolition-images'),
  dumpTicketsStorage: firebase.app().storage('gs://alba-demolition-dumptickets'),
  dailyReportsStorage: firebase.app().storage('gs://alba-demolition-daily-reports'),
  truckServiceStorage: firebase.app().storage('gs://alba-demolition-truck-service'),
  punchesStorage: firebase.app().storage('gs://alba-demolition-punches'),
  signatureStorage: firebase.app().storage().ref(),
  timestamp: firebase.firestore.FieldValue.serverTimestamp(),
  toolOrders_DB: firebase.firestore().collection('toolOrders'),
  workOrders_DB: firebase.firestore().collection('workOrders'),
  truckRequests_DB: firebase.firestore().collection('truckRequests'),
  toolPickups_DB: firebase.firestore().collection('toolPickups')
}

fb.signInSheetsStorage.ref().constructor.prototype.putFiles = function(files) {
  var ref = this;
  return Promise.all(
    files.map(function(file) {
      return ref.child(`${Date.now()}-${file.name}`).put(file);
    })
  );
};

fb.dumpTicketsStorage.ref().constructor.prototype.putFiles = function(files) {
  var ref = this;
  return Promise.all(
    files.map(function(file) {
      return ref.child(`${Date.now()}-${file.name}`).put(file);
    })
  );
};

// Strip the cache-busting ?v= that App.vue's update dialog reloads with - it has done
// its job, and leaving it in the URL would follow people into every link they share.
// Done here, before the router is attached, because vue-router rewrites the address
// bar to the route it started on once its first navigation finishes.
const loadedUrl = new URL(window.location.href)
if (loadedUrl.searchParams.has('v')) {
  loadedUrl.searchParams.delete('v')
  window.history.replaceState(window.history.state, '', loadedUrl.pathname + loadedUrl.search + loadedUrl.hash)
}

let app;
fb.auth.onAuthStateChanged(function() {
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      vuetify,
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
});

export default fb;

